import type { GTMEventReturnType, GTMRemoveLocationType } from '../GTM.types';
import GTMBaseModel from '../GTMBaseModel';

interface GTMOverviewFilterRemoveAllModelReturnType extends GTMEventReturnType {
    remove_location: GTMRemoveLocationType;
}

interface GTMOverviewFilterRemoveAllModelData {
    location: GTMRemoveLocationType;
}

export default class GTMOverviewFilterRemoveAllModel extends GTMBaseModel {
    public static parseToGTMData({
        location
    }: GTMOverviewFilterRemoveAllModelData): GTMOverviewFilterRemoveAllModelReturnType {
        return {
            ...GTMBaseModel.getBaseData(),
            ga4_property: 'cro_event',
            ga4_event_name: 'overview_filter_remove_all',
            remove_location: location
        };
    }
}
